import { bindEvents } from '../../assets/js/helpers';

import OverlayController from '../../assets/js/controller/overlay';
import SectionController from '../../assets/js/controller/section';


const selector = 'nav';

export default class Nav {

	constructor(section) {
		this.el = {
			section,
			openGallery: section.querySelector(`.${selector}__open-gallery`)
		};

		this.events = bindEvents(this);

		this.addEventListeners();
	}

	static get selector() {
		return selector;
	}

	_onOpenGalleryClick(e) {
		e.preventDefault();
		OverlayController.open('gallery');
		SectionController.globals.gallery.show();
	}

	addEventListeners() {
		this.el.openGallery.addEventListener('click', this.events._onOpenGalleryClick);
	}

	removeEventListeners() {
		this.el.openGallery.removeEventListener('click', this.events._onOpenGalleryClick);
	}

}
